import axios from 'axios'
import config from '../../../config'
import wrapper from 'axios-cache-plugin'

let cacheCard = wrapper(axios, {
  maxCacheSize: Infinity
});

cacheCard.__addFilter(/activity/)

let ActivityApi = {
  getActivityTrackingDetail(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/activity/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  },
  getActivityStepsTrackingDetail(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/activity/steps/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  },
  getActivityTrackingCard() {
    return axios.get(config.apiUrl + 'tracking/activity/card/?requestFrom=web')
  },
  addActivity(model) {
    return axios.post(config.apiUrl + 'tracking/activity/', model);
  },
  deleteActivityReading(progressId, trackingId) {
    return axios.delete(config.apiUrl + 'tracking/activity/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    })
  },
};

export default ActivityApi;



// WEBPACK FOOTER //
// ./src/api/Tracking/Activity/index.js